import React, { useState } from "react";

import {

  FaSyncAlt,
  FaDownload,
  FaPrint,
  FaShareAlt,
  FaWallet,
  FaInfoCircle,
  
  FaCheckCircle,
} from "react-icons/fa";

import "./IDCard.css";

function IDCard() {
  const [showBack, setShowBack] = useState(false);

  const member = {
    name: "Ramesh Babu",
    memberId: "APNBM240520001",
    fatherName: "Suresh Babu",
    dob: "12/05/1990",
    mobile: "+91 91234 56789",
    validTill: "19 May 2025",
    bloodGroup: "B+",
    membershipType: "Annual Membership",
    status: "Active",
    joiningDate: "20 May 2024",
    address:
      "D.No: 12-3-45, Guntur, Andhra Pradesh - 522001",
  };

  const downloadIdCard = () => {
    const content = `
APNB SEVA SAMITHI
& VIDYA CHARITABLE TRUST

MEMBERSHIP ID CARD
--------------------------------

Member ID: ${member.memberId}
Full Name: ${member.name}
Father / Husband Name: ${member.fatherName}
Date of Birth: ${member.dob}
Mobile Number: ${member.mobile}
Membership Type: ${member.membershipType}
Valid Till: ${member.validTill}
Status: ${member.status}

Trusted by Thousands of Families
`;

    const blob = new Blob([content], {
      type: "text/plain",
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;
    link.download = `${member.memberId}-ID-Card.txt`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  };

  const printIdCard = () => {
    window.print();
  };

  const shareIdCard = async () => {
    const shareText = `APNB Membership ID Card
Member: ${member.name}
Member ID: ${member.memberId}
Valid Till: ${member.validTill}`;

    if (navigator.share) {
      try {
        await navigator.share({
          title: "APNB Membership ID Card",
          text: shareText,
        });
      } catch (error) {
        console.log("Share cancelled");
      }
    } else {
      try {
        await navigator.clipboard.writeText(shareText);

        alert("Membership ID details copied.");
      } catch (error) {
        alert("Sharing is not supported on this browser.");
      }
    }
  };

  const addToWallet = () => {
    alert("Wallet integration can be connected later.");
  };

  return (
    <main className="id-card-page">

      {/* =====================================================
          PAGE HEADER
      ===================================================== */}

      <div className="id-page-header">

        <div>

          <h1>My ID Card</h1>

          <div className="id-breadcrumb">

            <span>Home</span>

            <span>›</span>

            <span>ID Card</span>

          </div>

        </div>

      </div>


      {/* =====================================================
          INFORMATION BAR
      ===================================================== */}

      <div className="id-information-bar">

        <FaInfoCircle />

        <span>
          Present this ID card to avail membership benefits
          and claim services.
        </span>

      </div>


      {/* =====================================================
          ID CARD SECTION
      ===================================================== */}

      <section className="id-card-section">

        <div className="id-card-section-header">

          <h2>Your Membership ID Card</h2>

          <button
            type="button"
            className="id-toggle-button"
            onClick={() => setShowBack(!showBack)}
          >
            <FaSyncAlt />

            {showBack
              ? "View Front Side"
              : "View Back Side"}
          </button>

        </div>


        {/* ===================================================
            CARD
        =================================================== */}

        <div className="id-card-display">

          {!showBack ? (

            /* =================================================
               FRONT SIDE
            ================================================= */

            <div className="membership-id-card front-card">

              <div className="id-card-top">

                <div className="id-logo-circle">
                  APNB
                </div>

                <div className="id-organization">

                  <h3>
                    APNB SEVA SAMITHI
                  </h3>

                  <h4>
                    & VIDYA CHARITABLE TRUST
                  </h4>

                  <p>
                    Serve The Community. Secure The Future.
                  </p>

                </div>

              </div>


              <div className="id-card-body">

                <div className="id-member-photo">

                  <span>
                    R
                  </span>

                </div>


                <div className="id-member-details">

                  <div className="id-card-title">
                    MEMBER ID CARD
                  </div>


                  <div className="id-detail-row">

                    <span>Member ID</span>

                    <strong>
                      {member.memberId}
                    </strong>

                  </div>


                  <div className="id-detail-row">

                    <span>Full Name</span>

                    <strong>
                      {member.name}
                    </strong>

                  </div>


                  <div className="id-detail-row">

                    <span>Father / Husband Name</span>

                    <strong>
                      {member.fatherName}
                    </strong>

                  </div>


                  <div className="id-detail-row">

                    <span>Date of Birth</span>

                    <strong>
                      {member.dob}
                    </strong>

                  </div>


                  <div className="id-detail-row">

                    <span>Mobile Number</span>

                    <strong>
                      {member.mobile}
                    </strong>

                  </div>


                  <div className="id-detail-row">

                    <span>Valid Till</span>

                    <strong>
                      {member.validTill}
                    </strong>

                  </div>

                </div>

              </div>


              <div className="id-card-footer">

                <span>
                  Trusted by Thousands of Families
                </span>

                <span>
                  APNB
                </span>

              </div>

            </div>

          ) : (

            /* =================================================
               BACK SIDE
            ================================================= */

            <div className="membership-id-card back-card">

              <div className="back-card-header">

                <div className="id-logo-circle">
                  APNB
                </div>

                <div>

                  <h3>
                    APNB SEVA SAMITHI
                  </h3>

                  <p>
                    & VIDYA CHARITABLE TRUST
                  </p>

                </div>

              </div>


              <div className="back-content">

                <div className="back-item">

                  <span>
                    Membership Type
                  </span>

                  <strong>
                    {member.membershipType}
                  </strong>

                </div>


                <div className="back-item">

                  <span>
                    Date of Joining
                  </span>

                  <strong>
                    {member.joiningDate}
                  </strong>

                </div>


                <div className="back-item">

                  <span>
                    Blood Group
                  </span>

                  <strong>
                    {member.bloodGroup}
                  </strong>

                </div>


                <div className="back-item">

                  <span>
                    Membership Status
                  </span>

                  <strong className="back-active">
                    <FaCheckCircle />
                    {member.status}
                  </strong>

                </div>


                <div className="back-address">

                  <span>
                    Address
                  </span>

                  <p>
                    {member.address}
                  </p>

                </div>

              </div>


              <div className="back-warning">

                <FaInfoCircle />

                <span>
                  This card is the property of APNB Seva
                  Samithi & Vidya Charitable Trust.
                </span>

              </div>


              <div className="id-card-footer">

                <span>
                  Trusted by Thousands of Families
                </span>

                <span>
                  APNB
                </span>

              </div>

            </div>

          )}

        </div>

      </section>


      {/* =====================================================
          ACTIONS
      ===================================================== */}

      <section className="id-actions-section">

        <h2>
          Actions
        </h2>


        <div className="id-actions-grid">

          {/* DOWNLOAD */}

          <button
            type="button"
            className="id-action-card"
            onClick={downloadIdCard}
          >

            <div className="id-action-icon blue">
              <FaDownload />
            </div>

            <strong>
              Download ID Card
            </strong>

            <span>
              Download your digital ID card
            </span>

          </button>


          {/* PRINT */}

          <button
            type="button"
            className="id-action-card"
            onClick={printIdCard}
          >

            <div className="id-action-icon green">
              <FaPrint />
            </div>

            <strong>
              Print ID Card
            </strong>

            <span>
              Print your ID card
            </span>

          </button>


          {/* SHARE */}

          <button
            type="button"
            className="id-action-card"
            onClick={shareIdCard}
          >

            <div className="id-action-icon purple">
              <FaShareAlt />
            </div>

            <strong>
              Share ID Card
            </strong>

            <span>
              Share with family members
            </span>

          </button>


          {/* WALLET */}

          <button
            type="button"
            className="id-action-card"
            onClick={addToWallet}
          >

            <div className="id-action-icon orange">
              <FaWallet />
            </div>

            <strong>
              Add to Wallet
            </strong>

            <span>
              Save to mobile wallet
            </span>

          </button>

        </div>

      </section>


      {/* =====================================================
          INFORMATION MESSAGE
      ===================================================== */}

      <div className="id-bottom-information">

        <FaInfoCircle />

        <span>
          Keep your membership ID card safely. You may
          present this card whenever membership
          verification is required.
        </span>

      </div>

    </main>
  );
}

export default IDCard;